<template>
  <div>
    <v-treeview
      dense
      :items="items"
      item-children="child_groups"
      item-key="rid"
      item-text="name"
      v-model="selectedGroupRid"
      @update:active="updateSelectedGroup"
      @update:open="(e) => (opened = e)"
      activatable
      :open="opened"
      selection-type="independent"
    >
      <template v-slot:label="{ item }">
        <v-card-text>
          <v-icon
            small
            class="mr-1"
            :color="selectedGroupRid[0] == item.rid ? 'primary' : ''"
          >
            {{
              selectedGroupRid[0] == item.rid ? "mdi-folder-lock" : "mdi-folder"
            }}
          </v-icon>
          {{ item.name }}
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                class="ml-5"
                @click.stop="openDialog(item)"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="primary">mdi-plus</v-icon>
              </v-btn>
            </template>
            <span> Создание вложенной группы </span>
          </v-tooltip>
        </v-card-text>
      </template>
    </v-treeview>
    <v-dialog v-model="createDialog" width="35%">
      <v-card>
        <v-card-title
          >Создание вложенной группы в '
          {{
            createForGroup ? createForGroup.name : "Не выбрана род группа"
          }}'</v-card-title
        >
        <v-form @submit.prevent="createNewGroup">
          <v-card-text>
            <v-text-field
              label="Название новой группы"
              v-model="newGroupName"
              required
              :rules="nameRules"
            />
          </v-card-text>
          <v-card-actions>
            <v-btn
              @click="
                createDialog = false;
                createForGroup = null;
              "
              color="error"
              outlined
              type="reset"
            >
              Отмена
            </v-btn>
            <v-btn
              :disabled="!createForGroup || !newGroupName"
              :loading="isLoading"
              type="submit"
              color="primary"
            >
              СОЗДАТЬ
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    createFunc: Function,
    updateFunc: Function,
    items: Array,
    updateKey: String,
    selected: Number,
  },
  data: () => ({
    createForGroup: null,
    selectedGroupRid: [],
    createDialog: false,
    newGroupName: "",
    nameRules: [(v) => !!v || "Обязательное поле"],
    opened: [],
    isLoading: false,
  }),
  methods: {
    async createNewGroup() {
      this.isLoading = true;
      let groupRid = await this.createFunc({
        parent: this.createForGroup,
        name: this.newGroupName,
      });
      if (groupRid != null && groupRid != undefined) {
        this.opened.push(this.createForGroup.rid);
        this.updateFunc({ key: this.updateKey, val: groupRid });
      }
      this.isLoading = false;
      this.createForGroup = null;
      this.createDialog = false;
    },
    openDialog(group) {
      this.createForGroup = group;
      this.createDialog = true;
    },
    updateSelectedGroup(e) {
      this.selectedGroupRid = [];
      if (e.length == 0) {
        this.updateFunc({
          key: this.updateKey,
          val: null,
        });
      } else {
        this.updateFunc({
          key: this.updateKey,
          val: e[0],
        });
        this.selectedGroupRid.push(e[0]);
      }
    },
  },
  mounted() {
    if (this.selected) {
      this.selectedGroupRid.push(this.selected);
    }
  },
};
</script>